module.exports = __webpack_public_path__ + "static/img/7.c8ff787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/7.png
// module id = a9Qs
// module chunks = 0